import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { trimSiteLabel } from "../../utils/siteChartUtils";

const ResponseChart = ({ list, compact = false }) => {
  const [chartData, setChartData] = useState({
    series: [],
    options: {},
  });

  let { width } = useWindowDimensions();
  const height = compact ? 240 : width > 1700 ? 382 : 282;

  useEffect(() => {
    if (list) {
      const categories = list?.map((e) => trimSiteLabel(e?.tagName)) || [];
      setChartData({
        series: [
          {
            name: "Positive Response",
            data: list?.map((e) => e.positive),
          },
          {
            name: "Negative Response",
            data: list?.map((e) => e.negative),
          },
        ],
        options: {
          chart: {
            type: "bar",
            height,
            toolbar: { show: false },
          },
          colors: ["#06D001", "#ff0000"],
          plotOptions: {
            bar: {
              columnWidth: compact ? "55%" : "30%",
              borderRadius: 3,
              borderWidth: 1,
            },
          },
          stroke: {
            show: true,
            width: 4,
            colors: ["transparent"],
          },
          dataLabels: { enabled: false },
          xaxis: {
            categories,
            labels: {
              rotate: -45,
              rotateAlways: categories.length > 6,
              hideOverlappingLabels: true,
              trim: true,
              style: { fontSize: "10px" },
            },
            tooltip: { enabled: false },
          },
          legend: {
            position: "top",
            horizontalAlign: "left",
            offsetY: 0,
            offsetX: -35,
          },
          tooltip: {
            x: {
              formatter: (_, { dataPointIndex }) => list?.[dataPointIndex]?.tagName || "",
            },
          },
        },
      });
    }
  }, [list, compact, height]);

  if (!list?.length) {
    return null;
  }

  return (
    <div className="response-chart-wrap">
      <ReactApexChart options={chartData.options} series={chartData.series} type="bar" height={height} />
    </div>
  );
};

export default ResponseChart;
